import { css } from 'linaria';

export const linkEvaluatorStyle = css`
  text-decoration: none;
  width: 100%;
  height: 100%;
`;
